import script from "./HipicaQuiz.vue?vue&type=script&setup=true&lang=js"
export * from "./HipicaQuiz.vue?vue&type=script&setup=true&lang=js"

import "./HipicaQuiz.vue?vue&type=style&index=0&id=d0f67d4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0f67d4a"]])

export default __exports__